import React from 'react';
import { createRoot } from 'react-dom/client';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import CssBaseline from '@mui/material/CssBaseline';

import store from 'store';

import App from './App';
import ThemeInjector from 'theme/ThemeInjector';
import reportWebVitals from './reportWebVitals';

// OpenLayers' stylesheet ships defaults for .ol-zoom, .ol-mouse-position,
// etc. that conflict with our custom layout. Importing it here (before
// index.css) ensures our overrides win the cascade. Previously imported
// inside the lazy-loaded MapView, where it landed after index.css and
// silently broke our overrides — see the commit that moved it.
import 'ol/ol.css';
import './index.css';

const root = createRoot(document.getElementById('root')!);
root.render(
    <Provider store={store}>
        <ThemeInjector>
            <CssBaseline />
            <Router>
                <App />
            </Router>
        </ThemeInjector>
    </Provider>,
);

reportWebVitals();
